// DS: C59
/** Main part of the popup and modal with links to share a deviation on social media */ import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import copy from 'copy-to-clipboard';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import InputSuccessMessage from '@wix/da-ds/pkg/formControls/lego/InputSuccessMessage';
import SocialShareButtons from '../../../SocialShareButtons';
import s from './DesktopShareContent.scss';
const DesktopShareContent = ({ url, title, embedCode, media, biData })=>{
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const [copied, setCopied] = useState('none');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SocialShareButtons, {
        url: url,
        title: title || url,
        media: media,
        buttons: [
            'facebook',
            'twitter',
            'tumblr'
        ],
        iconSize: 42,
        iconBgColor: "#0e0d20" // L8
        ,
        logoFillColor: "#00e59b" // G3
        ,
        biData: biData
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['first-copy-input']
    }, /*#__PURE__*/ React.createElement(TextInput, {
        id: "deviation-url-to-copy",
        value: url,
        label: t('share.linkUrl'),
        details: copied === 'url' ? /*#__PURE__*/ React.createElement(InputSuccessMessage, null, t('share.copied')) : undefined,
        ref: inputRef,
        onClick: ()=>{
            var _inputRef_current;
            copy(url);
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.select();
            setCopied('url');
        }
    })), embedCode && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(TextInput, {
        id: "deviation-url-to-copy",
        value: embedCode,
        label: t('share.embed'),
        details: copied === 'embed' ? /*#__PURE__*/ React.createElement(InputSuccessMessage, null, t('share.copied')) : undefined,
        ref: inputRef,
        onClick: ()=>{
            var _inputRef_current;
            copy(embedCode);
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.select();
            setCopied('embed');
        }
    })));
};
DesktopShareContent.displayName = 'DesktopShareContent';
export default DesktopShareContent;
